import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const trendKeys = {
    container: generateAutomationName("home", ["topics", "list", "item", "trend", "container"]),
    preLoader: generateAutomationName("home", ["topics", "preloader"]),
};

export const shareKeys = {
    wrapper: (name: string) => generateAutomationName("home", ["topics", "list", "item", name, "container"]),
    title: (name: string) => generateAutomationName("home", ["topics", "list", "item", name, "title"]),
    preLoader: generateAutomationName("home", ["topics", "preloader"]),
    data: (name: string) => generateAutomationName("home", ["topics", "list", "item", name, "data"]),
    percents: (name: string) => generateAutomationName("home", ["topics", "list", "item", name, "data", "value"]),
    change: (name: string) => generateAutomationName("home", ["topics", "list", "item", name, "data", "change"]),
};

export const pieGraphKeys = {
    wrapper: generateAutomationName("home", ["topics", "list", "item", "graph", "container"]),
};

export const menuKeys = {
    wrapper: generateAutomationName("home", ["topics", "list", "item", "menu", "container"]),
    item: generateAutomationName("home", ["menu", "item"]),
};

export const leaderKeys = {
    domain: generateAutomationName("home", ["topics", "list", "item", "leader", "domain"]),
    wrapper: (domain: string) =>
        generateAutomationName("home", ["topics", "list", "item", "leader", "container", domain]),
    title: generateAutomationName("home", ["topics", "list", "item", "leader", "title"]),
    preloader: generateAutomationName("home", ["topics", "preloader"]),
    value: generateAutomationName("home", ["topics", "list", "item", "leader", "share"]),
};

export const topIconKeys = {
    icon: generateAutomationName("home", ["topics", "list", "item", "topic", "icon"]),
    preLoader: generateAutomationName("home", ["topics", "topIcon", "preloader"]),
};

export const sharedTopicIconKeys = {
    wrapper: generateAutomationName("home", ["topics", "list", "item", "topic", "shared", "tooltip"]),
};

export const topicKWKeys = {
    preLoader: generateAutomationName("home", ["topics", "preloader"]),
    keywords: generateAutomationName("home", ["topics", "list", "item", "topic", "keywords"]),
};

export const topicNameKeys = {
    preLoader: generateAutomationName("home", ["topics", "preloader"]),
    name: (domain: string) => generateAutomationName("home", ["topics", "list", "item", "topic", "name", domain]),
};

export const topicKeys = {
    container: generateAutomationName("home", ["topics", "list", "item", "topic", "container"]),
    metaContainer: generateAutomationName("home", ["topics", "list", "item", "topic", "metadata", "container"]),
};
